/**
 * Anchor a bar tooltip at the top-center of the filled bar (not the column track).
 */
export const getBarTooltipAnchor = (
  root: HTMLElement,
  fill: Element | null,
): { x: number; y: number } => {
  const rootRect = root.getBoundingClientRect()
  const x = rootRect.width / 2

  if (!fill) {
    return { x, y: 4 }
  }

  const fillRect = fill.getBoundingClientRect()
  return {
    x,
    y: Math.max(0, fillRect.top - rootRect.top),
  }
}

/** For grouped bars — anchor to the tallest fill in the cluster. */
export const getTallestFillAnchor = (
  root: HTMLElement,
): { x: number; y: number } => {
  const fills = root.querySelectorAll('.ds-bar-chart__fill')
  if (fills.length === 0) {
    return getBarTooltipAnchor(root, null)
  }

  let tallest: Element = fills[0]
  let minTop = fills[0].getBoundingClientRect().top

  for (let i = 1; i < fills.length; i += 1) {
    const top = fills[i].getBoundingClientRect().top
    if (top < minTop) {
      minTop = top
      tallest = fills[i]
    }
  }

  return getBarTooltipAnchor(root, tallest)
}
